import {
  FilterOutlined,
  PlusOutlined,
  UndoOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { Tooltip, Button, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SetupStatusApi } from "../../api/SetupStatusApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import PageLoader from "../../components/sub/PageLoader";
import UsersTree from "../../components/tree/UsersTree";
import PositionsTable from "../../components/tables/PositionsTable";
import AddPositionModal from "../../components/modal/add/AddPositionModal";
import { GetPositionsApi } from "../../api/positions/GetPositionsApi";
import PositionsFilterModal from "../../components/modal/filters/PositionsFilterModal";
import FilterPositionsApi from "../../api/positions/FilterPositionsApi";
import { useSelector } from "react-redux";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function Positions() {
  const [canStart, setCanStart] = useState(false);
  const [data, setData] = useState();
  const [tree, setTree] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [tableLoading, setTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    getSetupProgress();
    setFilterBy({
      designation: "",
      userRoleId: "",
      status: "",
      unit: "",
    });
  }, []);

  async function getSetupProgress() {
    const apiResponse = await SetupStatusApi();
    if (apiResponse.success) {
      if (apiResponse.data?.positions) {
        getPositions(1);
      } else {
        getTopPosition(1);
      }
      setCanStart(true);
    }
  }

  async function getTopPosition(num) {
    const apiResponse = await GetPositionsApi(num, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setData(apiResponse.data);
    }
  }

  async function getPositions(num) {
    setTableLoading(true);
    const apiResponse = await GetPositionsApi(num, LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setData(apiResponse.data);
      setTableLoading(false);
      /*For the first user add */

      setPage(num);
    }
  }

  async function getFilteredPositions(values, num) {
    setTableLoading(true);
    const apiResponse = await FilterPositionsApi(
      values.designation || "",
      "",
      values.unit || "",
      values.userRoleId || "",
      values.status || "",
      num,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setFilterStatus(true);
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterBy({
        designation: values.designation,
        userRoleId: values.userRoleId,
        status: values.status,
        unit: values.unit,
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilteredPositions(filterBy, num);
    } else {
      getPositions(num);
    }
  }

  function resetFilter() {
    setFilterStatus(false);
    getPositions(1);
    setFilterBy();
  }

  const right = (
    <>
      {!tree && (
        <>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => resetFilter()}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "positions", "add") && (
        <Tooltip placement="left" title={"Add Position"}>
          <Button
            className="ml-3"
            onClick={() => setAddModal(true)}
            shape="circle"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = (
    <>
      <div className="pri-font text-lg">
        {"Positions (" + (data?.totalCount || 0) + ")"}
      </div>
      {/* {canShow &&
          (tree ? (
            <Tooltip title={"Table view"}>
              <Button onClick={() => setTree(false)} className="ml-3">
                <TableOutlined />
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title={"Tree view"}>
              <Button onClick={() => setTree(true)} className="ml-3">
                <ApartmentOutlined />
              </Button>
            </Tooltip>
          ))} */}
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            tree ? (
              <UsersTree />
            ) : (
              <PositionsTable
                changePage={(num) => changeTablePage(num)}
                data={data}
                loading={tableLoading}
                page={page}
              />
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddPositionModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => getPositions(1)}
      />
      <PositionsFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilteredPositions(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default Positions;
